import React from 'react';
import InlineSVG from 'react-svg-inline';
import keyIcon from '../../../imgs/key-icon.svg';
import styles from '../Header.scss';
import {isAuthenticated, removeAuthToken, removeUserId} from '../../../logic/authHelpers';

const logOut = (e) => {
  e.preventDefault();
  e.stopPropagation();
  removeAuthToken();
  removeUserId();
  //TODO: remove partnerId
  window.location.reload();
};

export default function HeaderMobileAuthBtn(props) {
  let content;
  if (isAuthenticated()) {
    content = (
      <a
        className="link"
        onClick={logOut}
        href="#">
        {props.userId || 'undefined'}
      </a>
    );
  } else {
    content = (
      <InlineSVG
        onClick={props.actions.openSignInPopup}
        svg={keyIcon} />
    );
  }

  return (
    <div className={styles.mobileAuthBtn}>
      {content}
    </div>
  );
}



/** WEBPACK FOOTER **
 ** ./src/components/Header/elements/HeaderMobileAuthBtn.jsx
 **/